import { createContext, useContext } from 'react'

// The labels come from the server, so the page never depends on the JS translation bundle
export const TranslationsContext = createContext({})

export const useT = () => useContext(TranslationsContext)

export const interpolate = (text, values) =>
  Object.entries(values).reduce((result, [key, value]) => result.replace(`%{${key}}`, value), text || '')
